import React, { useEffect, useState } from "react";
import { darkTheme } from "@yleisradio/yds-core";
import styled from "styled-components";

import { useEmbedParametersContext } from "../contexts/embedParametersContext";
import {
  getTimeRemaining,
  secondsToHHMMSSFormat
} from "../helpers/timeHelpers";
import { usePlayerStore } from "../store/usePlayerStore";

const TimeLeftOverlay = styled.div`
  align-items: center;
  background: rgb(26 27 28 / 60%);
  border-radius: 4px;
  bottom: 8px;
  color: ${darkTheme.TEXT_DEFAULT};
  display: flex;
  font-size: 12px;
  font-weight: 700;
  height: 20px;
  justify-content: center;
  line-height: 12px;
  padding: 0 4px;
  position: absolute;
  right: 8px;
`;

export const TimeLeft = () => {
  const { getState, subscribe, useStoreState } = usePlayerStore();
  const durationInSeconds = useStoreState.durationInSeconds();
  const isControlsVisible = useStoreState.isControlsVisible();
  const isEnded = useStoreState.isEnded();

  const { loop } = useEmbedParametersContext();

  const [isVisible, setIsVisible] = useState(!getState().isControlsVisible);
  const [timeRemainging, setTimeRemainging] = useState(0);

  useEffect(() => {
    if (!durationInSeconds || !isVisible) return;

    const unsubscribe = subscribe(
      state => state.currentTime,
      currentTime => {
        setTimeRemainging(getTimeRemaining(currentTime, durationInSeconds));
      },
      {
        fireImmediately: true
      }
    );

    return () => {
      unsubscribe();
    };
  }, [durationInSeconds, isVisible, subscribe]);

  useEffect(() => {
    if (isEnded && !loop) {
      setIsVisible(false);
    } else {
      setIsVisible(!isControlsVisible);
    }
  }, [isControlsVisible, isEnded, loop]);

  return isVisible ? (
    <TimeLeftOverlay>-{secondsToHHMMSSFormat(timeRemainging)}</TimeLeftOverlay>
  ) : null;
};
